export class Debounce {
	timeout = 0;

    debounce(time, fn) {
		clearTimeout(this.timeout);
		this.timeout = setTimeout(fn, time);
    }
}
